import { useEffect } from 'react';
import { useBuildex } from '@/hooks/use-buildex/index';
import { useTradex } from '@/hooks/use-tradex/index';
import { useHealthdex } from '@/hooks/use-healthdex/index';

const useFavicon = () => {
	const isBuildex = useBuildex();
	const isTradex = useTradex();
	const isHealthdex = useHealthdex();

	useEffect(() => {
		let faviconUrl = '';

		if (isBuildex) {
			faviconUrl = '/buildex-favicon.ico';
		} else if (isTradex) {
			faviconUrl = '/tradex-favicon.ico';
		}
		else if (isHealthdex) {
			faviconUrl = '/healthdex-favicon.ico';
		}
		else {
			faviconUrl = '/favicon.png';
		}

		const updateFavicon = (rel, url) => {
			let existingLink = document.querySelector(`link[rel='${rel}']`);
			if (existingLink) existingLink.parentNode.removeChild(existingLink);

			if (url) {
				const link = document.createElement('link');
				link.rel = rel;
				link.href = `${url}?v=${new Date().getTime()}`; // Cache busting
				document.head.appendChild(link);
			}
		};

		updateFavicon('icon', faviconUrl); // Standard favicon
		updateFavicon('apple-touch-icon', faviconUrl); // Apple Touch Icon for Safari/iOS
	}, [isBuildex, isTradex, isHealthdex]);
};

export default useFavicon;
